import React, { Component } from 'react';
import Header from './../common/Header';
import { Button, Card } from 'reactstrap';
import { connect } from 'react-redux';
import { productNameChange, productDescriptionChange, productLinkChange, productPictureLinkChange, productMessageChange } from '../../actions/Products/ProductAction';

class AddProducts extends Component {

    onProductNameChange(event) {
        this.props.productNameChange(event);
    }

    onProductDescriptionChange(event) {
        this.props.productDescriptionChange(event);
    }

    onProductLinkChange(event) {
        this.props.productLinkChange(event);
    }

    onProductPictureLinkChange(event) {
        this.props.productPictureLinkChange(event);
    }

    onProductMessageChange(event) {
        this.props.productMessageChange(event);
    }

    render() {
        return (
            <div>
                <Header />
                <div style={{ padding: 30, width: '100%', paddingTop: 40 }}>
                    <Card style={styles.cardStyle}>
                        <div className="row">
                            <div className="col">
                                <div>
                                    <h6 style={{ fontFamily: "Source Sans Pro-SemiBold" }}>
                                        Product Name
                                    </h6>
                                    <input
                                        style={styles.inputStyle}
                                        value={this.props.productName}
                                        onChange={event => this.onProductNameChange(event.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col">
                                <div>
                                    <h6 style={{ fontFamily: "Source Sans Pro-SemiBold" }}>
                                        Product Description
                                    </h6>
                                    <textarea
                                        style={styles.textAreaStyle}
                                        value={this.props.productDescription}
                                        onChange={event => this.onProductDescriptionChange(event.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{ paddingTop: 20 }}>
                            <div className="col">
                                <div>
                                    <h6 style={{ fontFamily: "Source Sans Pro-SemiBold" }}>
                                        Product Link
                                    </h6>
                                    <input
                                        style={styles.inputStyle}
                                        value={this.props.productLink}
                                        onChange={event => this.onProductLinkChange(event.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col">
                                <div>
                                    <h6 style={{ fontFamily: "Source Sans Pro-SemiBold" }}>
                                        Product Picture Link
                                    </h6>
                                    <input
                                        style={styles.inputStyle}
                                        value={this.props.productPictureLink}
                                        onChange={event => this.onProductPictureLinkChange(event.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{ paddingTop: 20 }}>
                            <div className="col">
                                <div>
                                    <h6 style={{ fontFamily: "Source Sans Pro-SemiBold" }}>
                                       Message for the Product
                                    </h6>
                                    <textarea
                                        style={styles.textAreaStyle}
                                        value={this.props.productMessage}
                                        onChange={event => this.onProductMessageChange(event.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col" />
                        </div>
                        <div style={{ paddingTop: 20 }}>
                            <Button style={styles.buttonStyle}>
                                Submit & Publish
                            </Button>
                        </div>
                    </Card>
                </div>
            </div>
        );
    }
}

const styles = {
    inputStyle: {
        width: '75%',
        height: 40,
        paddingLeft: 20,
        borderRadius: '4px',
        borderColor: '#ced4da',
        borderTopColor: '#ced4da',
        boxShadow: 'none',
        fontFamily: 'Source Sans Pro-SemiBold',
        outlineWidth: 0,
        borderWidth: '0.5px'
    },
    textAreaStyle: {
        width: '75%',
        height: 60,
        paddingLeft: 20,
        borderRadius: '4px',
        borderColor: '#ced4da',
        borderTopColor: '#ced4da',
        boxShadow: 'none',
        fontFamily: 'Source Sans Pro-SemiBold',
        outlineWidth: 0
    },
    cardStyle: {
        borderColor: '#7ed321',
        padding: 30,
        width: '90%',
        margin: 'auto',
        boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`,
        borderRadius: 10
    },
    buttonStyle: {
        fontFamily: "Source Sans Pro-SemiBold",
        backgroundColor: '#40b508',
        borderWidth: 0,
        boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`
    }
};

function mapStateToProps(state) {
    return {
        productName: state.product.productName,
        productDescription: state.product.productDescription,
        productLink: state.product.productLink,
        productPictureLink: state.product.productPictureLink,
        productMessage: state.product.productMessage
    };
}

export default connect(mapStateToProps, { productNameChange, productDescriptionChange, productLinkChange, productPictureLinkChange, productMessageChange })(AddProducts);



// WEBPACK FOOTER //
// ./src/components/Products/AddProducts.js